import { createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme) =>
  createStyles({
    beneficiaries: {
      [theme.breakpoints.down('md')]: {
        textAlign: 'left',
      },
      [theme.breakpoints.up('md')]: {
        textAlign: 'end',
      },
    },
    button: {
      background: theme.palette.background.default,
    },
    loading: {
      padding: theme.spacing(2),
    },
    bannerWrapper: {
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(2, 0, 3),
      },
      [theme.breakpoints.up('md')]: {
        margin: theme.spacing(-2, 0, 3),
      },
    },
    valuationGroupTitle: {
      marginBottom: theme.spacing(2),
      fontWeight: 700,
    },
    adminMessage: {
      marginBottom: 0,
      fontStyle: 'italic',
    },
    disclaimer: {
      maxWidth: 600,
    },
    ownershipInfo: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
  })
);
